<template>
  <router-view v-if="$route.meta.hideLayout" />
  <div class="common-layout" v-if="$route.name && !$route.meta.hideLayout">
    <el-container direction="vertical">
      <el-header height="auto" class="header disable-select" padding="0">
        <div class="header-panel">
          <router-link to="/" class="decorate-off">
            <logo />
          </router-link>
          <el-dropdown
            ref="loginMenu"
            trigger="contextmenu"
            v-if="$auth.check()"
            placement="bottom-end"
            :hide-on-click="false"
          >
            <el-button type="success" round @click="showUserMenu">
              <el-avatar src="" :size="24">
                <img src="../assets/profile.png" />
              </el-avatar>
              <span>{{ userName }}</span>
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item class="gap-10 item-text" v-if="userEmail">
                  <font-awesome-icon :icon="['fas', 'envelope']" class="main-menu-buttin-icon" />
                  <span>{{ userEmail }}</span>
                </el-dropdown-item>
                <el-dropdown-item class="gap-10 item-text" v-if="userLocation">
                  <font-awesome-icon :icon="['fas', 'location-dot']" class="main-menu-buttin-icon" />
                  <span>{{ userLocation }}</span>
                </el-dropdown-item>
                <el-dropdown-item @click="logout" class="gap-10" divided>
                  <font-awesome-icon :icon="['fas', 'right-from-bracket']" class="main-menu-buttin-icon" />
                  <span>Выйти</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <el-button type="success" round @click="redirectLogin" v-else>
            <font-awesome-icon :icon="['fas', 'right-to-bracket']" class="main-menu-buttin-icon" />
            <span>Войти</span>
          </el-button>
        </div>
        <menu-panel v-if="$route.name && $route.meta.hasMenu !== false" />
      </el-header>
      <div class="wrap-main">
        <el-main>
          <!-- <router-view /> -->
          <router-view v-slot="{ Component }">
            {{ Component.key }}
            <template v-if="$route.meta.cacheComponent">
              <keep-alive>
                <component :is="Component" />
              </keep-alive>
            </template>
            <template v-else>
              <component :is="Component" />
            </template>
          </router-view>
        </el-main>
        <el-footer class="primary">
          <el-row align="middle">
            <el-col :sm="8">
              <div>Дата обновления: {{ mixins.getDateTime() }}</div>
            </el-col>
            <el-col :sm="8">
              <div>
                {{ `© ${getYear()} - METRO ${appVersion}` }}
              </div>
            </el-col>
            <el-col :sm="8" style="display: none">
              <div class="footer-col text-end">
                Разработчик
                <a href="https://www.arsis.ru" target="_blank">Арсис</a>
                <img alt="Arsis logo" src="../assets/arsis.png" height="18" />
              </div>
            </el-col>
          </el-row>
        </el-footer>
      </div>
    </el-container>
  </div>
</template>

<script lang="ts" setup>
import { emitter, MittType } from "@/plugins/event-bus";
import { ref, computed } from "vue";
import { useAuth } from "vue-auth3";
import Logo from "@/components/Logo.vue";
import MenuPanel from "@/components/MenuPanel.vue";
import mixins from "@/mixins";
import router from "@/router";
import type { DropdownInstance } from "element-plus";

const auth = useAuth();
const appVersion: string = process.env.VUE_APP_VERSION;
const loginMenu = ref<DropdownInstance>();
emitter.on(MittType.autofocus, () => mixins.triggerFocus());
emitter.on(MittType.tabChange, () => mixins.triggerRepaintGrids());

window.addEventListener("resize", () => emitter.emit(MittType.resize));

function getYear() {
  return mixins.formatDate(new Date(), "YYYY");
}

function showUserMenu() {
  if (!loginMenu.value) return;
  loginMenu.value.handleOpen();
}

function logout() {
  auth.logout({
    makeRequest: false,
    redirect: { name: "login" },
  });
}

function redirectLogin() {
  router.push("login");
}
const userName = computed(() => {
  return (auth.state.data && (auth.state.data.name || auth.state.data.email)) || "empty";
});
const userEmail = computed(() => {
  return auth.state.data && auth.state.data.email;
});
const userLocation = computed(() => {
  return auth.state.data && [auth.state.data.country, auth.state.data.location].filter((x) => x).join(", ");
});
</script>
